import { render, staticRenderFns } from "./wasteGarden.vue?vue&type=template&id=6f658b5d&scoped=true&"
import script from "./wasteGarden.vue?vue&type=script&lang=js&"
export * from "./wasteGarden.vue?vue&type=script&lang=js&"
import style0 from "./wasteGarden.vue?vue&type=style&index=0&id=6f658b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f658b5d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
